import React from "react";

export function Card({ className = "", children, ...props }) {
  return (
    <div
      className={`bg-surface border border-line rounded-sm transition-colors duration-150 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className = "", children }) {
  return <div className={`px-4 pt-4 pb-2 ${className}`}>{children}</div>;
}

export function CardTitle({ className = "", children }) {
  return (
    <h3 className={`head text-sm font-semibold tracking-tight text-ink ${className}`}>
      {children}
    </h3>
  );
}

export function CardContent({ className = "", children }) {
  return <div className={`px-4 pb-4 ${className}`}>{children}</div>;
}
